module.exports = __webpack_public_path__ + "site/img/logo_black.ba5e57a3.svg";